/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { ImageItem } from './image-item';
// May contain unused imports in some cases
// @ts-ignore
import { MMIngredientResponse } from './mmingredient-response';
// May contain unused imports in some cases
// @ts-ignore
import { MMealPortionResponse } from './mmeal-portion-response';

/**
 * 
 * @export
 * @interface MMealResponse
 */
export interface MMealResponse {
    /**
     * 
     * @type {string}
     * @memberof MMealResponse
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof MMealResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MMealResponse
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof MMealResponse
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof MMealResponse
     */
    'portionUnit'?: MMealResponsePortionUnitEnum;
    /**
     * 
     * @type {Set<MMealPortionResponse>}
     * @memberof MMealResponse
     */
    'portions'?: Set<MMealPortionResponse>;
    /**
     * 
     * @type {Set<string>}
     * @memberof MMealResponse
     */
    'allergens'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof MMealResponse
     */
    'tags'?: Set<string>;
    /**
     * 
     * @type {Array<ImageItem>}
     * @memberof MMealResponse
     */
    'images'?: Array<ImageItem>;
    /**
     * 
     * @type {Array<MMIngredientResponse>}
     * @memberof MMealResponse
     */
    'ingredients'?: Array<MMIngredientResponse>;
}

export const MMealResponsePortionUnitEnum = {
    Gram: 'GRAM',
    Portion: 'PORTION',
    Piece: 'PIECE'
} as const;

export type MMealResponsePortionUnitEnum = typeof MMealResponsePortionUnitEnum[keyof typeof MMealResponsePortionUnitEnum];


